import { render } from "./ConnectWallet.vue?vue&type=template&id=5ea61cff&ts=true"
import script from "./ConnectWallet.vue?vue&type=script&lang=ts"
export * from "./ConnectWallet.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__